/**
 * HomePage - Service homepage with AppLayout wrapper
 * Uses disableContentPaddings for edge-to-edge hero header
 * @module components/starnexus/home/HomePage
 */

import React, { useState } from 'react';
import AppLayout from '@amzn/awsui-components-console/app-layout';
import { Navigation } from '../common/Navigation';
import { TopNav } from '../common/TopNav';
import { HomepageContent } from './HomepageContent';
import './styles.css';

export const HomePage: React.FC = () => {
  const [navigationOpen, setNavigationOpen] = useState(true);

  return (
    <>
      <TopNav />
      <AppLayout
        navigation={<Navigation />}
        content={<HomepageContent />}
        contentType="default"
        disableContentPaddings={true}
        navigationOpen={navigationOpen}
        onNavigationChange={(event) => setNavigationOpen(event.detail.open)}
        toolsHide={true}
        headerSelector="#top-nav"
      />
    </>
  );
};

export default HomePage;
